import { TEMPLATES, templateToProjectData } from '../data/templates';
import { useToleranceStore } from '../stores/toleranceStore';
import { useProjectStore } from '../stores/projectStore';
import { SCHRITTE } from './schritte';
import { VORLAGE_ID, zielOderNichts, statusUpdate, tourEreignis } from './tourLogik';
import { useTourStore } from './tourStore';
import { useAuthStore } from '../stores/authStore';

const vorlage = () => TEMPLATES.find((t) => t.id === VORLAGE_ID);

function lade(startCounted) {
  const tpl = vorlage();
  const st = useToleranceStore.getState();
  // loadProject setzt den Namen schon; setCalculationName würde isDirty setzen.
  st.loadProject(templateToProjectData(tpl), tpl.name, null, null, { proMode: true, startCounted });
  useProjectStore.getState().detachCurrentCalculation();
}

// In der Tour ist das Ergebnis für alle sichtbar (es ist ein Beispiel).
export function ladeBeispiel() { lade(true); }

export function beendeTour(wahl, { isPro }) {
  if (wahl === 'leer') {
    useToleranceStore.getState().newProject();
    useProjectStore.getState().detachCurrentCalculation();
  } else if (!isPro) {
    // Free: wie aus der Vorlagen-Galerie, Berechnen zählt gegen das Budget.
    lade(false);
  }
}

const istSichtbar = (sel) => Boolean(zielOderNichts(sel));

export function baueSchritte({ sichtbar = istSichtbar } = {}) {
  return SCHRITTE.map((s) => {
    const ersatz = s.ersatz && s.ziel && !sichtbar(s.ziel) ? s.ersatz : null;
    const ziel = ersatz ? ersatz.ziel : s.ziel;
    return {
      element: ziel ? () => zielOderNichts(ziel) : undefined,
      popover: { title: s.titel, description: ersatz ? ersatz.text : s.text, side: s.seite, align: 'start' },
    };
  });
}

// Esc, X oder Klick daneben: auf dem letzten Schritt ist die Tour gesehen,
// das zählt wie „Beispiel behalten“. Vorher ist es ein Abbruch.
export function beimSchliessen(d, abschliessen) {
  if (d.isLastStep()) abschliessen('behalten');
  else d.destroy();
}

export async function startTour({ isPro, onFertig, onAbbruch }) {
  const [{ driver }] = await Promise.all([import('driver.js'), import('driver.js/dist/driver.css'), import('./tour.css')]);
  let fertig = false;
  const abschliessen = (wahl) => { fertig = true; beendeTour(wahl, { isPro }); d.destroy(); onFertig(); };
  const d = driver({
    showProgress: true,
    progressText: '{{current}} von {{total}}',
    nextBtnText: 'Weiter',
    prevBtnText: 'Zurück',
    doneBtnText: 'Beispiel behalten',
    closeBtnLabel: 'Tour beenden',
    popoverClass: 'toleranz-tour',
    steps: baueSchritte(),
    onPopoverRender: (popover, { state }) => {
      if (state.activeIndex !== SCHRITTE.length - 1) return;
      const leer = document.createElement('button');
      leer.type = 'button';
      leer.textContent = 'Leer starten';
      leer.className = 'driver-popover-footer-btn';
      leer.addEventListener('click', () => abschliessen('leer'));
      popover.footerButtons.prepend(leer);
    },
    onDoneClick: () => abschliessen('behalten'),
    onDestroyStarted: () => beimSchliessen(d, abschliessen),
    onDestroyed: () => { if (!fertig) onAbbruch(); },
  });
  d.drive();
  return d;
}

// Abbruch (Esc, X, Klick daneben) oder Ladefehler: Free-Nutzer behalten das
// Beispiel, aber nicht als gerechnet (sonst wäre es eine Freikarte fürs
// Monatsbudget). Banner erst beim nächsten Besuch wieder.
export function abbrechenAufraeumen({ isPro }) {
  if (!isPro) lade(false);
  const t = useTourStore.getState();
  t.setAktiv(false);
  t.setSpaeter();
}

// Startet die angeforderte Tour genau einmal (StrictMode ruft Effekte doppelt).
export async function starteAngefordert({ isPro, start = startTour }) {
  const t = useTourStore.getState();
  if (!t.startAngefordert || t.aktiv) return false;
  t.startErledigt();
  ladeBeispiel();
  t.setAktiv(true);
  tourEreignis('start');
  try {
    await start({
      isPro,
      onFertig: async () => {
        const st = useTourStore.getState();
        st.setAktiv(false);
        st.setSpaeter();
        tourEreignis('fertig');
        try { await useAuthStore.getState().updateProfile(statusUpdate('done')); }
        catch (e) { console.warn('Tour-Status nicht gespeichert:', e); }
      },
      onAbbruch: () => { abbrechenAufraeumen({ isPro }); tourEreignis('abbruch'); },
    });
    return true;
  } catch (e) {
    console.warn('Tour konnte nicht starten:', e);
    abbrechenAufraeumen({ isPro });
    return false;
  }
}
